import { Link } from 'react-router-dom'
import { getOrdinalSuffix, FormatISODateTime, FormatISODate } from '../../../helpers/formatting'

export default function DeferCountOverrideForm(props) {
  const { responseData } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval for customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link> to defer a {getOrdinalSuffix(+responseData?.loan?.deferred_payment_count)} payment on Loan <Link to={`payment_schedule/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.loan?.label}</b></Link>. Payment date: {FormatISODate(responseData?.payment?.scheduled_date)}.
      </h3>
      <h3>{responseData?.description}</h3>
      <div className="divider m-0 my-2"></div>
    </>
  )
}
